export default __webpack_public_path__ + "static/media/show-dnv.fca288fa.jpg";